<template>
    <v-autocomplete
        v-if           = "items"
        :items         = "items"
        item-value     = "id"
        :item-text     = "itemText"
        :label         = "label"
        v-model        = "seletced"
        :return-object = true
        :rules         = "rules"
        :clearable     = "clearable"
        :readonly      = "readonly"
        @change        = "onChange"
        :hide-details  = "hideDetails"
    />
</template>

<script>
export default {
    name : "FEnumAutocomplete",
    props: {
        value: {
            required: true
        },
        label: {
            required: true,
        },
        module: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        rules: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        },
        clearable: {
            type: Boolean,
            required: false,
            default: function () {
                return false;
            }
        },
        hideDetails: {
            type: Boolean,
            required: false,
            default: function () {
                return false;
            }
        },
        itemText: {
            required: false,
            default: function () {
                return "name";
            }
        },
        readonly: {
            type: Boolean,
            required: false,
            default: function () {
                return false;
            }
        },
    },

    computed: {
        items () {
            const enums = this.$store.getters [this.module];
            return enums[this.type]
        }
    },

    data: () => ({
        seletced: null,
    }),

    mounted() {
        this.seletced = this.value;
    },

    watch: {
        value () {
            this.seletced = this.value;
        }
    },

    methods: {
        onChange () {
            this.$emit('input', this.seletced);
            this.$emit('change', this.seletced);
        }
    }
}
</script>

<style scoped>

</style>